<div class="sdp-ngx-accordion">
  <div class="header">
    <div class="toggle-open-button" (click)="toggleViewMode()" [ngClass]="{'closed': scIsCollapsed}">
      <sabis-ngx-arrow-icon class="toggle-icon"></sabis-ngx-arrow-icon>
      <p class="title">{{ scTitle }}</p>
    </div>
    <div class="divider"></div>
  </div>
  <div class="content" [hidden]="!scIsCollapsed" [@fadeInOut]>
    <ng-template [ngTemplateOutlet]="templateRef"></ng-template>
  </div>
</div>
